// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Custom styles for TimePicker */\n.react-time-picker {\n    font-family: 'Open Sans', sans-serif;\n}\n\n.react-time-picker__wrapper-light {\n    color: #222222;\n}\n\n.react-time-picker__wrapper-light .react-time-picker__clear-button svg {\n    stroke: #222222;\n}\n\n.react-time-picker__wrapper-dark {\n    color: #D3CFC9;\n}\n\n.react-time-picker__wrapper-dark .react-time-picker__clear-button svg {\n    stroke: #D3CFC9;\n}\n", ""]);
// Exports
module.exports = exports;
